module.exports = __webpack_public_path__ + "img/1524001457.409430cf.jpg";